import { render, staticRenderFns } from "./orderConfirm.vue?vue&type=template&id=931bb214&scoped=true"
import script from "./orderConfirm.vue?vue&type=script&lang=js"
export * from "./orderConfirm.vue?vue&type=script&lang=js"
import style0 from "./orderConfirm.vue?vue&type=style&index=0&id=931bb214&prod&lang=less&scoped=true"
import style1 from "./orderConfirm.vue?vue&type=style&index=1&id=931bb214&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931bb214",
  null
  
)

export default component.exports